"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import Link from "next/link";
import { Button } from "../ui/button";
import { ArrowRight, Loader2 } from "lucide-react";
import { createClient } from "@/lib/supabase/client";
import { cn } from "@/lib/utils";
const GoogleIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className={"h-4 w-4 fill-white\n"} viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 11.989h11.49c.08.52.12 1.05.12 1.59 0 5.94-3.98 10.16-10.08 10.16A11.5 11.5 0 0 1 11.9.24c3.08 0 5.66 1.13 7.63 2.98l-3.18 3.11c-.84-.8-2.32-1.74-4.45-1.74-3.82 0-6.94 3.17-6.94 7.07s3.12 7.07 6.94 7.07c4.43 0 6.09-3.17 6.34-4.81H12v-4.86Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export function DashboardButton({
  className,
  children,
  variant = "default"
}: {
  className?: string;
  children?: ReactNode;
  variant?: "default" | "green";
}) {
  const {
    user,
    loading
  } = useAuth();
  const [signingIn, setSigningIn] = useState(false);
  const handleGoogleLogin = async () => {
    try {
      setSigningIn(true);
      const supabase = createClient();
      const redirectTo = `${window.location.origin}/auth/callback`;
      const {
        error
      } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo
        }
      });
      if (error) {
        console.error(error);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSigningIn(false);
    }
  };
  if (loading) {
    return <Button disabled size="lg" className={"px-8 bg-emerald-600 text-white rounded-full"}>
        Loading...
      </Button>;
  }
  if (user) {
    return <Button size="lg" asChild className={cn("!rounded-full", variant === "green" ? "bg-emerald-600 hover:bg-emerald-700 text-white" : "bg-gray-900 hover:bg-gray-800 text-white", className)}>
        <Link href="/dashboard">
          {children || "Dashboard"}
          <ArrowRight className={cn(variant === "green" && "ml-2 h-5 w-5", !variant || variant === "default" ? "ml-2 h-4 w-4" : "")} />
        </Link>
      </Button>;
  }
  return <Button onClick={handleGoogleLogin} disabled={signingIn} size="lg" className={cn("!rounded-full", variant === "green" ? "bg-emerald-600 hover:bg-emerald-700 text-white" : "bg-[#4285F4] hover:bg-[#357ae8] text-white", className)}>
      {signingIn ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : variant === "green" ? null : <GoogleIcon />}
      <span className={cn(variant === "green" ? "" : "ml-2")}>
        {children || "Sign in with Google"}
      </span>
      {variant === "green" && !signingIn && <ArrowRight className="ml-2 h-5 w-5" />}
    </Button>;
}